<template>
  <div class="report-detail-container">
    <header class="header-content">
      <h1 class="main-title">这一路</h1>
      <p class="sub-title">✨ 我们见证了你的闪光</p>
    </header>

    <section class="content-section">
      <p class="body-text">参与的每一个活动，</p>
      <p class="body-text">获得的每一张证书，</p>
      <p class="body-text">都是你不断追求卓越的印记~</p>
      <p class="body-text">坚持不懈地学习与成长，</p>
      <p class="body-text">你的职场之路将更加宽广。</p>

      <div class="honor-card" v-if="certificate.length">
        <p class="honor-title">获得荣誉：</p>
        <div class="honor-list">
          <div class="honor-item" v-for="(item, index) in certificate" :key="index">
            <span class="honor-icon">🏅</span>
            <span class="honor-name">{{ item }}</span>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  props: ["ReportData"],
  data() {
    return {
      certificate: []
    }
  },
  created() {
    if (this.ReportData.activityJinggan) {
      try {
        const raw = String(this.ReportData.activityJinggan).replace(/^["""]|["""]$/g, '');
        const items = raw.split(',').map(s => s.trim().replace(/["""]/g, '').trim()).filter(Boolean);
        this.certificate = items;
      } catch (e) {
        console.error('解析activity数据失败', e);
      }
    }
  }
}
</script>

<style scoped>
.report-detail-container {
  width: 100%;
  height: 100vh;
  background: 
    url("../../assets/26July/logo.png") right top no-repeat,
    url("../../assets/26July/bg.jpg") no-repeat;
  background-size: 100% 100%, cover;
  color: #000;
  padding: 0 10%;
  box-sizing: border-box;
  overflow: hidden;
}

.header-content {
  padding-top: 8vh;
  margin-bottom: 3vh;
  text-align: center;
}

.main-title {
  font-size: 36px;
  font-weight: 800;
  margin: 0;
  color: #2d3748;
  letter-spacing: 4px;
}

.sub-title {
  font-size: 20px;
  font-weight: 600;
  color: #5C2E2E;
  margin-top: 12px;
  opacity: 0.85;
}

.content-section {
  text-align: center;
}

.body-text {
  font-size: 17px;
  line-height: 1.6;
  color: #333;
  margin: 6px 0;
  font-weight: 400;
}

.honor-card {
  /* margin-top: 10px; */
  background: rgba(255, 255, 255, 0.55);
  backdrop-filter: blur(15px);
  border-radius: 24px;
  padding: 20px 12px;
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.4);
  text-align: left;
}

.honor-title {
  font-size: 18px;
  font-weight: 600;
  color: #333;
  margin: 0 0 5px;
}

.honor-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.honor-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 14px;
  background: rgba(172, 155, 226, 0.1);
  border-radius: 12px;
}

.honor-icon {
  font-size: 24px;
}

.honor-name {
  font-size: 16px;
  font-weight: 500;
  color: #333;
}

@media screen and (min-width: 786px) {
  .report-detail-container {
    background-image: url("../../assets/26July/pcbg.png");
    background-size: cover;
  }

  .main-title {
    font-size: 48px;
  }

  .sub-title {
    font-size: 24px;
  }

  .honor-card {
    max-width: 500px;
    margin-left: auto;
    margin-right: auto;
  }
}
</style>
